import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  addGatesData,
  deleteGatesData,
  fetchGates,
  updateGatesList,
} from "../../apis/gates";

export const fetchGatesList = createAsyncThunk(
  "gates/fetchGates",
  async (_, { rejectWithValue }) => {
    try {
      const gates = await fetchGates();
      return gates;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  },{
        condition: (_, { getState }) => {
          const state = getState() as any; // Replace 'any' with your RootState type
          return !state.gates.isDataFetched; // Adjust path based on your state structure
        }
      }
);

export const updateGates = createAsyncThunk(
  "gates/updateGates",
  async (
    {
      gate_id,
      data,
    }: {
      gate_id: string;
      data: {
        [key: string]: any;
        gate_id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const updated = await updateGatesList(gate_id, data);
      return updated;
    } catch (error: any) {
      const msg = error?.response?.data?.message || error?.message || "Unknown error";
      return rejectWithValue(msg);
    }
  }
);

export const deleteGates = createAsyncThunk(
  "gates/deleteGates",
  async (
    {
      id,
    }: {
      id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await deleteGatesData(id);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewGatesData = createAsyncThunk(
  "gates/addGates",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addGatesData(data);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
